import { Link } from "react-router-dom";
import type { Topic } from "@/mocks/topics";

export default function RelatedTopics({ topics }: { topics: Topic[] }) {
  if (topics.length === 0) return null;

  return (
    <section className="rounded-lg bg-background-50 border border-background-200/80 p-5 md:p-7">
      <h2 className="font-heading font-bold text-lg text-foreground-950 mb-5 flex items-center gap-2">
        <i className="ri-links-line text-secondary-500"></i>
        相关推荐
      </h2>
      <ul className="flex flex-col gap-4">
        {topics.map((t) => (
          <li key={t.id}>
            <Link to={`/topic/${t.id}`} className="group flex gap-3 cursor-pointer">
              <span className="w-16 h-16 shrink-0 rounded-md overflow-hidden bg-background-200">
                <img src={t.cover} alt={`${t.title} 封面`} title={t.title} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
              </span>
              <div className="min-w-0">
                <p className="text-sm text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">{t.title}</p>
                <p className="text-xs text-foreground-500 mt-1.5 flex items-center gap-3">
                  <span>{t.categoryName}</span>
                  <span className="flex items-center gap-1"><i className="ri-chat-3-line"></i>{t.commentCount}</span>
                </p>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}